import { memo } from 'react';

import { merge } from '@/components';
import { Button, Flex, Heading, ProgressBar, Text } from '@/components/core';
import { CloseIcon } from '@/components/icons';
import { useDots } from '@/hooks';
import { useInboxStore } from '@/store';
import { DivProps } from '@/utils';

export type RerunAgentRunsProps = Omit<DivProps, 'children'> & {
  progress: number;
};

const IRerunAgentRuns = ({ progress, className, ...rest }: RerunAgentRunsProps) => {
  const selectedRunIds = useInboxStore((state) => state.selectedRunIds);

  const dots = useDots();

  return (
    <Flex col className={merge('gap-sm', className)} {...rest}>
      <Flex className="items-start">
        <Heading>Rerunning {dots}</Heading>
        <div className="grow" />
        <Button onPress={close} variant="plain">
          <CloseIcon />
        </Button>
      </Flex>
      <Flex col className="gap-sm">
        <Text>
          {Math.floor(progress * selectedRunIds.size)} of {selectedRunIds.size} files
        </Text>
        <ProgressBar variant="primary" value={progress * 100} className="w-full" />
      </Flex>
    </Flex>
  );
};

export const RerunAgentRuns = memo(IRerunAgentRuns) as typeof IRerunAgentRuns;
